// @flow
import {imageDataToCanvas, resizeCanvas} from "canvas-utils";


export const imageDataToimage = function(imageData: string) : Promise<Image> {
  return urlToimage(imageData);
};

export const urlToimage = function(url: string) : Promise<Image> {
  return new Promise(function(resolve, reject){
    var image = new Image();
    image.onload = function() {
      resolve(image);
    };
    image.onerror = function(e){
      reject(e);
    };
    image.src = url;
  });
};


export const resizeImageData = function(imageData: string, maxWidth: number, maxHeight: number, maintainRatio?: boolean = true) : Promise<HTMLCanvasElement> {
  return imageDataToCanvas(imageData).then((canvas)=>{
    return resizeCanvas(canvas, maxWidth, maxHeight, maintainRatio).toDataURL("image/jpeg");
  });
};

export const rotateImageData = function(imageData: string, rotation: number) : Promise<string> {
  return imageDataToCanvas(imageData, rotation).then((canvas)=>{
    return canvas.toDataURL("image/jpeg");
  });
};

export const fileToImageData = function(file: File) : Promise<string> {
  var fileReader = new FileReader();
  var promise = new Promise(function(resolve, reject) {
    fileReader.onload = function() {
      resolve(this.result);
    };
    fileReader.onerror = function(e) {
      reject(e);
    };
  });
  fileReader.readAsDataURL(file);
  return promise;
};


export const imageDataIsLandscape = function(imageData: string) : Promise<boolean> {
  return imageDataToimage(imageData).then((image) => image.width > image.height);
};
export const imageDataIsPortrait = function(imageData: string) : Promise<boolean> {
  return imageDataIsLandscape(imageData).then((landscape) => !landscape);
};
